import { Flex, Text, TextInput } from '@tremor/react'

interface IInput {
    label: string
    value: string
    setValue: (v: string) => void
    required: boolean
}

export default function Input({ label, value, setValue, required }: IInput) {
    return (
        <Flex flexDirection="row">
            <Text className="w-36">{label}:</Text>
            <TextInput
                value={value}
                onValueChange={setValue}
                error={required && value === ''}
            />
        </Flex>
    )
}
